import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network';
import { Platform } from 'ionic-angular';

/**
 * Network Provider
 *
 * Ce service permet d'accéder à la connexion de l'utilisateur
 */
@Injectable()
export class NetworkProvider {

  /**
   * Constructeur
   *
   * Crée une instance de NetworkProvider.
   *
   * @param {Network} network
   */
  constructor(
    public network: Network,
    private platform: Platform
  ) {
  }

  /**
   * Récupération du statut de connexion du téléphone
   */
  isConnected(){
    let platform = this.platform.is('core') || this.platform.is('mobileweb') ? false : true;
    if (!platform)
      return window.navigator.onLine;
    else
      return this.network.type !== 'none';
  }

}



// WEBPACK FOOTER //
// ./src/providers/network/network.ts